// extracted by mini-css-extract-plugin
export default {"container":"BZ-z","list":"CZ-z"};